<template>
  <div>
    <div class="page-header">
      <div class="container-fluid">
        <h2 class="h5 no-margin-bottom">Yeni Servis</h2>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-12">
                  <div class="row">


                          <div class="col-lg-4 col-12">
                            <label class="form-control-label">Anagrup</label>
                            <input disabled type="text" class="form-control" :value="cariveadres.cihazgrup">
                          </div>
                          <div class="col-lg-4 col-12">
                            <label class="form-control-label">Altgrup</label>
                            <input disabled type="text" class="form-control" :value="cariveadres.cihazaltgrup">
                          </div>
                          <div class="col-lg-4 col-12">
                            <label class="form-control-label dashtext-1">SeriNo</label>
                            <input disabled type="text" class="form-control" :value="cariveadres.chz_serino">
                          </div>

                          <div class="col-lg-8 col-12 mt-3">
                            <label class="form-control-label">Ünvan</label>
                            <input disabled type="text" class="form-control" :value="cariveadres.unvan">
                          </div>
                          <div class="col-lg-4 col-12 mt-3">
                            <label class="form-control-label">İç Lokasyon</label>
                            <input disabled type="text" class="form-control" :value="cariveadres.lokasyon">
                          </div>
                          <div class="col-lg-12 col-12 mt-3">
                            <label class="form-control-label dashtext-1">Adres</label>
                            <input disabled type="text" class="form-control" :value="cariveadres.adres">
                          </div>

                          <div class="col-12 mt-3" v-if="carilist">

                                <label class="form-control-label dashtext-3 (*)">Müşteri *</label>
                                <input  class="form-control mb-2" placeholder="Genel Arama" v-model="search" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
                                <!-- v-if="search.length>3" -->
                                <div>
                                  <table id="tablo" v-if="search.length>2" >
                                    <tr @click="itemClicked(post)" v-for="(post,index) in filteredItems(posts,'unvan')" :key="index">
                                      <td style="font-size:17px; padding:10px 5px 10px 10px;margin-bottom:5px; background:#36393F; border-bottom:1px solid #3D4247">
                                        <div> <strong class="dashtext-3">{{post.carikod}}</strong>  <strong>{{$helper.ilkharfBuyuk(post.unvan)}}</strong> </div>
                                        <div class="my-2"><strong>{{post.adres}}</strong> </div>

                                      </td>
                                      <!-- <td>+</td> -->
                                    </tr>                          
                                  </table>

                                </div>

                                <!-- <v-autocomplete :items="items" v-model='item' :get-label='getLabel' :min-len='0' @update-items='update' :component-item='tpl' @item-selected="itemSelected" @item-clicked="itemClicked" :input-attrs="{name: 'input-test', id: 'v-my-autocomplete'}">
                                </v-autocomplete> -->
                            </div>
                  </div>
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="table-responsive"> 
                          <table id="tablo" class="table table-striped">
                              <tbody class="bg-dark">
                              <tr v-for="post in cihaz" :key="post.id">
                                <td>{{post.no}}</td>

                                <td>{{post.serino}}</td>
                                <td>{{post.model}}</td>
                                <td>{{$helper.trtgoster(post.tarih)}}</td>
                                <td class="dashtext-3">{{post.sn}}</td>
                              </tr>
                              </tbody>

                            </table>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                      <div class="row mb-3">
 <!-- @change="stchange($event)"-->
                        <div class="col-lg-6 col-12">
                        <label class="form-control-label dashtext-3">Servis Tipi *</label>
                          <select  v-model="newpost.st" class="form-control">
                            <option value="0">Servis Tipi Seç</option>
                            <option v-for="(option,index) in st" :value="option.id" :key="index">{{ option.alias }}
                            </option>
                          </select>
                        </div>

                        <div class="col-lg-6 col-12">
                          <label class="form-control-label">Sağlayıcı</label>
                            <select disabled  v-model="newpost.sa" class="form-control">
                              <option value="0">Sağlayıcı Yok</option>
                              <option v-for="(option,index) in salar" :value="option.id" :key="index">{{ option.alias }}</option>
                            </select>
                        </div>

                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-6 col-12">
                          <label class="form-control-label dashtext-3">Servis Nedeni ***</label>
                            <select v-model="newpost.sn" class="form-control">
                              <option value="0">Servis Nedeni Seç</option>
                              <option v-for="(option,index) in reversedMessage" :value="option.id" :key="index">{{ option.alias }}
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label dashtext-3">Servis Öncelik</label>
                            <select v-model="newpost.so" class="form-control">
                            <option value="0">Servis Öncelik Seç</option>
                            <option value="1">Düşük</option>
                            <option value="2">Orta</option>
                            <option value="3">Yüksek</option>
                            </select>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label">Çağrı Tarihi</label>
                            <input readonly type="text" class="form-control" v-model="newpost.ct">
                        </div>
                        <div class="col-lg-6 col-12">
                            <label class="form-control-label">Çağrı Saati</label>
                            <input readonly type="time" class="form-control" v-model="newpost.cs">
                        </div>
                      </div>
                      
                      <div class="row mt-4 mb-3">
                        <div class="col-12">
                           <textarea style="height:100px" v-model="newpost.not" placeholder="Servis Notu" class="form-control" rows="10"></textarea>
                        </div>
                      </div>
                      <div class="row mt-3 mb-3">
                        <div class="col-lg-6 col-12">
                          <button @click="newpost.sd = 1; newpost.bolge = 0" class="btn btn-outline-danger w-100 btn-lg">Beklemede Kalsın</button>
                        </div>
                         <div class="col-lg-6 col-12">
                           <button @click="newpost.sd = 2" class="btn btn-outline-info btn-lg w-100">Hemen Yönlendir</button>
                         </div>
                      </div>
                      <div v-if="newpost.sd === 2" class="row mt-3 mb-3">

                        <div class="col-12">
                          <label class="form-control-label">Yönlendirilecek Bölge</label>
                            <select v-model="newpost.bolge" class="form-control">
                            <option v-for="(option,index) in bolge" :value="option.id" :key="index">{{ option.alias }}</option>
                            </select>
                        </div>
 
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                           <button :disabled="progres.inprogres" @click="sendNewPost()" class="btn btn-danger d-block w-100 btn-lg">Servis Ekle</button>
                        </div>
                      </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
<!--{{item}}-->
<div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>
import Autocomplete from './Autocomplete.vue'
import tpl from './TplItem.vue'
//import Animals from './animals.js'
export default {
  name: 'demo',
  components: {'v-autocomplete': Autocomplete},
  data () {
    return {
      carilist:false,
      search: '',
      currentTag: "All",
      kesif:false,
      montaj:false,
      itemsApi: [],
      item: {},
      items: [],
      posts:[],
      tpl: tpl,
      searchText:'',
      error:[],
      cihaz:[],
      donem : this.$request.donem(),
      kid:this.$request.ayar().kid,
      ya:this.$request.ayar().ya,
      sn:[],
      st:[],
      so:[],
      salar:[],
      bolge:[],
      akod:'', // sn süzmek için cihazgrup kodunu aldık
      txt:'',
      cariveadres:{},
      newpost: {
        firma: this.$request.ayar().firmaid,
        id: '',
        sn: 0,
        st: 0,
        so: 0,
        sa: 0,
        sd:1, // beklemede mi yönlenmiş mi
        ct:this.$helper.getNow().tarih,
        cs:this.$helper.getNow().saat,
        not:'',
       // ckod:'',
        //cad:'',
        carid:0,
        servisno:'',
        bolge:0,
      },
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      source:this.$store.getters.getsource
  }    
  },
    created() {
//      await this.cdgetir('cd')
     // this.progres.inprogres = true
      //this.sagetir();
      this.yetki(this.sagetir,this.stf,this.sof)
      //setInterval(this.getNow,1000);
      //this.getPostsAsync()
      this.getcihaz_ve_adresi()
    },
  computed: {

    reversedMessage () {
      if(this.newpost.st!=0){
      if (this.newpost.st === 2){
       this.$request.get("servis/sngetir/"+this.akod)
        .then(res=> {this.sn = res.results})
      }
      else{

        this.$request.get("servis/sngetir2/"+this.newpost.st)
        .then(res => {this.sn = res.results
          if (this.newpost.st!=2){this.newpost.sn = res.results[0].id }
          else{
            //this.newpost.sn=0
            }
        })
        .catch(err => this.error.push(err))
        
      }
      }
      return this.sn
    }
  }, 
  methods: {
    yetki : function(sa,st,so){ 
          if (this.$helper.sayfayetki(610696)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                this.txt="where k.kid_ ="+this.kid //sagetir için
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
                this.txt="where s.firma ="+this.newpost.firma //sagetir için
            }
                if(islem){this.sagetir()}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
          sa();
          st();
          so();
          this.itemSelected();
    },
    getcihaz_ve_adresi(){

      var index = this.source.findIndex((word) => word.cihazid == this.$route.params.guid);
      console.log(this.source[index])
      this.cariveadres = this.source[index];
      this.newpost.id = this.$route.params.guid;
      this.akod = this.source[index].anakod;
      this.newpost.carid = this.source[index].subeid;

      if (this.source[index].adres == "")  {
        this.$swal({
              title: 'Belirsiz Cari',
              text: 'Bu cihaz için sadece montaj servis tipini öneriyoruz',
              icon: 'warning',
              //showCancelButton: true,
        }).then((result) => {
          if(result.value) {
            this.progres.inprogres = true
            this.sttip(); // cari list çağırır
          }
        })
      }

    },
    sagetir(){
          this.$request.get("servis/sagetir/"+this.txt)
          .then(res => {
            if (res.status === 200){this.salar = res.results}
            else{this.sa.push({"id" : 0,"alias" : "Sağlayıcı yok"})}
          })
          .catch(err => this.error.push(err))
    },

    sendNewPost(){
      if (this.newpost.st!=0 && this.newpost.sd!=0 && this.newpost.so!=0 && this.newpost.sn!=0 && this.newpost.carid) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Servisi Eklenecek...',
              icon: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    this.progres.inprogres = true;
                    this.progres.mesaj = 'Bekleyiniz...';
                    this.$request.get("servis/serviscount/"+this.newpost.firma+"/"+this.donem)
                      .then(res => {
                        if (res.status === 200) 
                        {
                          this.newpost.servisno = res.results[0].adet
                          this.sendNewPost2()
                        }
                      })
                      //.catch(err)
                  }
                })
     }
     else{
       this.$swal("Girdileri Kontrol Et")
     } 
     },
    sendNewPost2(){
      this.$request.post("servis/servis/",this.newpost)
      .then(res => {
        let log = {
          servis_id : res.data.id,
          tarih:res.data.tarih,
          saat : res.data.saat,
          sd:res.data.sd,
          kid:this.kid,
          islem: 'Servis Eklendi'
        }
          this.$request.post("servis/servis_log/",log)
            .then(res => {
                //this.progres.inprogres = true;
                this.progres.mesaj = 'Log Kaydı Yapıldı...';
               this.$swal('İşlem Başarılı', 'Servis Başarı ile açıldı', 'success')
            })
            this.progres.inprogres = false;
            this.progres.mesaj = 'Servis Eklendi...';
      })
      .catch(err => {this.error.push(err)
            this.progres.inprogres = false;
            this.progres.mesaj = 'Tekrar Deneyin...';
      })
    },

    itemSelected () { // cihaz id ye göre cihaz geçmişi
      this.$request.get("servis/detay/cihaz/"+this.$route.params.guid+'/'+this.donem)
      .then(data => {
        this.$store.dispatch('view_servis',data.results).then(sonuc=>{
          this.cihaz = sonuc.sort((t1,t2) => t1.id > t2.id ? -1 : 1)
        })

      })
      .catch(err => {this.error.push(err)})

    },

    // stchange(event){
    //   this.progres.inprogres = true
    //   if (this.$route.params.guid==0) {
    //     this.$swal("Sadece Keşif")
    //     this.newpost.st =  3;
    //   }
    //   if (event.target.value==4) {
    //     this.newpost.st =  4;
    //     this.montaj =  true;

    //   }
    //   if (event.target.value==3) {
    //     this.newpost.st = 3;
    //     this.kesif = true;

    //   }
    //   this.progres.inprogres = false
    //   console.log(this.newpost)


    // },
    itemClicked (item) {
      console.log(item)
      this.newpost.carid = item.subeid;
      this.cariveadres.adres = item.adres;
      this.cariveadres.unvan = item.unvan;
      this.search = ""
    },
    sttip(){
      this.newpost.sn = 0;

      this.$request.post("servis/api", {q:'cari_adres',where:{}})
      .then(res => {
        this.posts=res.data;
        this.progres.inprogres = false
        this.carilist = true
      })
      .catch(err => {
        this.errors.push(err)
        this.progres.inprogres = false
      })


    },

    stf(){
      this.$request.get("servis/stgetir")
      .then(res => {this.st = res.results
      this.sof('so')
      })
      .catch(err => this.error.push(err))
    },

    sof(tip){
      this.$request.get("servis/define/"+this.newpost.firma+"/so")
      .then(res => {this.so = res.results
      this.bolgegetir()
      })
      .catch(err => this.error.psuh(err))
       
    },
    bolgegetir(){
      this.$request.get("servis/bolge/"+this.newpost.firma)
      .then(res => {this.bolge = res.results
      this.progres.inprogres = false
      setTimeout(()=> {this.progres.inprogres = false}, (1000) ) 
      })
    },
    filter: function(tag) {
          this.currentTag = tag;
    },
    filteredItems: function(array,field) {
        var filter = this.currentTag;
        if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
    }
  },
  // watch: {
  //   akod(val){
  //     this.fullName = val + ' ' + this.lastName
  //   },
  // },
}
</script>
<style scoped>
#arama{height: calc(2.4rem + 45px) !important;font-size: 56px !important; border-radius:0%;}

.form-control{height: calc(2.4rem + 15px);font-size: 16px; border-radius:0%;}
</style>


// WEBPACK FOOTER //
// src/views/servis/create.vue